export default {"src":"/_next/static/media/arrow-button.e187aaae.svg","height":21,"width":28,"blurWidth":0,"blurHeight":0};